import { Link } from 'react-router-dom';

export default function JoinCta() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="relative overflow-hidden rounded-lg">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20floating%20speech%20bubble%20shapes%20and%20soft%20glowing%20spark%20particles%2C%20coral%20orange%20amber%20gold%20and%20jade%20green%20tones%2C%20bold%20modern%20graphic%20art%2C%20playful%20energetic%20composition%2C%20no%20people%2C%20no%20text&width=1600&height=640&seq=tangxin-cta-01&orientation=landscape"
            alt="暖色调渐变背景上漂浮着气泡与光点，象征网友一起玩梗的热闹氛围"
            title="糖心吃瓜 投稿与分享"
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/35" />

          <div className="relative z-10 px-6 py-12 md:px-14 md:py-16">
            <div className="max-w-xl">
              <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1.5 text-xs text-background-100 backdrop-blur-sm">
                <i className="ri-megaphone-line text-accent-300" aria-hidden="true" />
                开放投稿中
              </span>
              <h2 className="mt-4 text-2xl text-background-50 md:text-4xl">
                刷到好玩的名场面？丢给我们
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-background-200 md:text-base">
                不管是热评、弹幕、群聊片段还是接梗合集，只要够热闹、够好玩，都欢迎投稿。
                我们会认真看每一条线索，并标注整理来源。
              </p>
              <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
                <Link
                  to="/contact"
                  className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-secondary-950 transition-colors hover:bg-accent-400"
                >
                  <i className="ri-send-plane-line" aria-hidden="true" />
                  提交投稿
                </Link>
                <Link
                  to="/about"
                  className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 bg-background-50/10 px-6 py-3 text-sm text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20"
                >
                  了解我们怎么整理内容
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}